import request from '@/utils/request'


// 查询师傅钱包记录列表
export function listWalletRecord(query) {
  return request({
    url: '/master/master-wallet-record/list',
    method: 'get',
    params: query
  })
}

// 查询师傅钱包记录分页
export function pageWalletRecord(query) {
  return request({
    url: '/master/master-wallet-record/page',
    method: 'get',
    params: query
  })
}

// 查询师傅钱包记录详细
export function getWalletRecord(data) {
  return request({
    url: '/master/master-wallet-record/detail',
    method: 'get',
    params: data
  })
}

// 新增师傅钱包记录
export function addWalletRecord(data) {
  return request({
    url: '/master/master-wallet-record/add',
    method: 'post',
    data: data
  })
}

// 修改师傅钱包记录
export function updateWalletRecord(data) {
  return request({
    url: '/master/master-wallet-record/edit',
    method: 'post',
    data: data
  })
}

// 删除师傅钱包记录
export function delWalletRecord(data) {
  return request({
    url: '/master/master-wallet-record/delete',
    method: 'post',
    data: data
  })
}
